import styles from "./SectionTitle.module.scss";
import React, { ReactElement } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function SectionTitle(): ReactElement | null {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  const navigateHome = () => {
    navigate("/");
  };

  return (
    <>
      <div className={styles.header}>
        <h1 onClick={navigateHome}>
          Flare Advisor
          {import.meta.env.VITE_DEPLOY_TARGET !== "production"
            ? ` - ${import.meta.env.VITE_DEPLOY_TARGET}`
            : ""}
        </h1>
      </div>
      <promo-banner></promo-banner>
    </>
  );
}
